import React, { useEffect, useState } from "react";
import PrivateLayout from "../../layouts/privateLayout";
import { Box, Button, Container, useMediaQuery, useTheme } from "@mui/material";
import BasicBreadcrumbs from "../../components/breadcrumb";
import { useLocation, useParams } from "react-router-dom";
import { jobGrade } from "../../data/jobGradeData";
import Form from "./form";
import EmployeeList from "./employeeList";
import { Add } from "@mui/icons-material";
import PointModal from "./modal";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";

const Details = () => {
  const { id } = useParams();
  const location = useLocation();
  const [mode, setMode] = useState("view");
  const [open, setOpen] = useState(false);

  const themeuse = useTheme();
  const isMobile = useMediaQuery(themeuse.breakpoints.down("sm"));

  useEffect(() => {
    if (location.pathname.includes("edit-point")) {
      setMode("edit");
    } else if (location.pathname.includes("view-point")) {
      setMode("view");
    } else {
      setMode("create");
    }
  }, [location.pathname]);
  const data = jobGrade.find((u) => u.id === Number(id));

  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <BasicBreadcrumbs 
          first={
                <Link component={RouterLink} to="/earn-point" underline="hover" color="primary.main">
                  Employee Earned point
                </Link>
              }
              second="Listing"
            />
          <Button
            display="none"
            variant="contained"
            size="medium"
            startIcon={<Add />}
            fullWidth={isMobile}
            onClick={() => setOpen(true)} // 👉 opens the modal
            sx={{
              backgroundColor: "secondary.main",
              fontWeight: "600",
              "&:hover": { backgroundColor: "secondary.dark" },
              whiteSpace: "nowrap",
              hidden: "true",
            }}
          >
            Adjustment Point
          </Button>

          <PointModal
            open={open}
            onClose={() => setOpen(false)}
            onSave={(payload) => {
              // payload = { type: "add" | "deduct", totalPoint: signedNumber, remark: string }
              console.log("Saved:", payload);
            }}
          />
        </Box>

        <Box sx={{ width: "100%" }}>
          {/* <Form mode={mode} jobData={data} onModeChange={setMode} /> */}
          <EmployeeList />
        </Box>
      </Box>
    </PrivateLayout>
  );
};

export default Details;
